import label from "@/lang/StaticLabels.js";

// PBASE Navbar  -----------------------------------------------
let navItems = [
  {
    title: label.modules.pbase,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PCRMDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PCRMCompanyInfo",
        label: label.menu.companyInfo,
        metaLabel: label.page.companyInfo,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: null,
        label: label.menu.customerInfo,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PCRMPersonClubList",
            label: label.menu.customerManagement,
            metaLabel: label.page.customerManagement,
            icon: "mdi-circle-small",
          },
          {
            to: "PCRMPersonClubGrouping",
            label: label.menu.customerGrouping,
            metaLabel: label.page.customerGrouping,
            icon: "mdi-circle-small",
          },
          {
            to: "PCRMPersonClubGrade",
            label: label.menu.customerGrade,
            metaLabel: label.page.customerGrade,
            icon: "mdi-circle-small",
          },
          {
            to: "PCRMPersonClubTagsTypes",
            label: label.menu.customerTagsTypes,
            metaLabel: label.page.customerTagsTypes,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: "PCRMSalesChannels",
        label: label.menu.salesChannelsTypes,
        metaLabel: label.page.salesChannelsTypes,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },

      {
        to: "PCRMIntroducedType",
        label: label.menu.introducedType,
        metaLabel: label.page.introducedType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },

      {
        to: "PCRMDeliveryMethod",
        label: label.menu.deliveryMethod,
        metaLabel: label.page.deliveryMethod,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PCRMPaymentMethod",
        label: label.menu.paymentMethod,
        metaLabel: label.page.paymentMethod,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PCRMFeedbackType",
        label: label.menu.feedBackType,
        metaLabel: label.page.feedBackType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMFeedbackQuestionOption",
        label: label.menu.feedBackQuestionOption,
        metaLabel: label.page.feedBackQuestionOption,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
       {
        to: "PCRMServiceCenter",
        label: label.menu.serviceCenters,
        metaLabel: label.page.serviceCenters,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMSystemSetting",
        label: label.menu.settings,
        metaLabel: label.page.systemSetting,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMCongratulationsMsgSettings",
        label: label.menu.congratulationsMessageSettings,
        metaLabel: label.page.congratulationsMessageSettings,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMProfileSettings",
        label: label.menu.profileCompletionSettings,
        metaLabel: label.page.profileCompletionSettings,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: "PCRMDiscountList",
        label: label.menu.discountCodes,
        metaLabel: label.page.discountCodes,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMProcessList",
        label:
          label.menu.autoProcesses + "(" + label.menu.interactivePolicies + ")",
        metaLabel: label.page.autoProcesses,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },

      {
        to: "PCRMPOrderList",
        label: label.menu.manageOrders,
        metaLabel: label.page.orders,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMFeedbackList",
        label: label.menu.feedBackManagement,
        metaLabel: label.page.feedBack,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: "PCRMCustomerCreditVoucher",
        label: label.menu.customerCreditVoucher,
        metaLabel: label.page.customerCreditVoucher,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMCustomerScoreVoucher",
        label: label.menu.customerScoreVoucher,
        metaLabel: label.page.customerScoreVoucher,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMCustomerScoreSummery",
        label: label.menu.scoreSummery,
        metaLabel: label.page.scoreSummery,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMComprehensiveCustomer",
        label: label.menu.comprehensiveCustomerReport,
        metaLabel: label.page.comprehensiveCustomerReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMMostCustomerRegistrations",
        label: label.menu.userPerformanceReport,
        metaLabel: label.page.userPerformanceReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },

      {
        to: "PCRMFeedbackHistories",
        label: label.menu.feedbackHistories,
        metaLabel: label.page.feedbackHistories,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMFeedBackByQuestion",
        label: label.menu.feedBackByQuestion,
        metaLabel: label.page.feedBackByQuestion,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMFeedbackReport",
        label: label.menu.feedbackReport,
        metaLabel: label.page.feedbackReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PCRMFeedbackHistoryAllDetails",
        label: label.menu.historyAllDetails,
        metaLabel: label.page.historyAllDetails,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
